import React, { useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { http } from "@/lib/api";
import { useOptions } from "@/hooks/useOptions";
import { FormDrawer } from "@/components/kit/FormDrawer";
import { SelectField } from "@/components/kit/fields";
import { toast } from "sonner";

const empty = { advertiser_id: "", product_id: "", vertical: "",
  payment_model: "CPA", currency: "USD" };

export function CreateOfferCardDialog({ open, onOpenChange }) {
  const opts = useOptions();
  const qc = useQueryClient();
  const [form, setForm] = useState(empty);
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (open) setForm(empty); }, [open]);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  // auto-fill vertical from the selected product (the product also names the offer)
  const onProduct = (pid) => {
    const p = opts.products.find((x) => x.id === pid);
    setForm((f) => ({ ...f, product_id: pid, vertical: p?.vertical || f.vertical }));
  };

  const save = async () => {
    if (!form.advertiser_id || !form.product_id) return toast.error("Advertiser and Product are required");
    setBusy(true);
    try {
      await http.post("/offer-cards", form);
      qc.invalidateQueries({ queryKey: ["offer-cards"] });
      toast.success("Offer created — add GEOs to it next");
      onOpenChange(false);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed to create offer card");
    } finally {
      setBusy(false);
    }
  };

  return (
    <FormDrawer open={open} onOpenChange={onOpenChange} title="New Offer" subtitle="Create the offer card — add GEOs inside it next"
      size="md" onSave={save} saving={busy} saveLabel="Create offer" testId="create-offer-card">
      <div className="space-y-5">
        <SelectField label="Advertiser" value={form.advertiser_id} onChange={(v) => set("advertiser_id", v)}
          options={opts.advertisers.map((a) => ({ value: a.id, label: a.name }))} testId="card-advertiser" />
        <SelectField label="Product" value={form.product_id} onChange={onProduct}
          options={opts.products.map((p) => ({ value: p.id, label: p.name }))} testId="card-product"
          hint="The product name becomes the offer name." />
        <SelectField label="Vertical" value={form.vertical} onChange={(v) => set("vertical", v)}
          options={opts.verticals} testId="card-vertical" hint="Auto-filled from the product, editable." />
        <div className="grid grid-cols-2 gap-4">
          <SelectField label="Default payment model" value={form.payment_model} onChange={(v) => set("payment_model", v)} options={opts.payment_models} testId="card-model" />
        </div>
      </div>
    </FormDrawer>
  );
}
